import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pageable } from '@ms/core/components/table/pageable.model';
import { KeyValueDTO } from '@ms/core/model/keyvalue.model';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BudgetAccountSearch, IAccountAutocomplete, IBudgetAccount } from '../budget-accounts/budget-accounts.model';
import { httpParams } from '../shared/http-utils';
import { IPage } from '../shared/page/page.model';

@Injectable({
    providedIn: 'root',
})
export class BudgetAccountService {
    baseUrl = '/school-service/api/budget-accounts';

    constructor(private http: HttpClient) {
        console.log('Budget Account service created');
    }

    getBudgetAccountById(id: string): Observable<HttpResponse<IBudgetAccount>> {
        return this.http.get<IBudgetAccount>(`${this.baseUrl}/${id}`, {
            observe: 'response',
        });
    }

    getBudgetAccounts(): Observable<IBudgetAccount[]> {
        return this.http.get<IBudgetAccount[]>(this.baseUrl);
    }

    getActiveBudgetAccounts(): Observable<IBudgetAccount[]> {
        return this.http.get<IBudgetAccount[]>(`${this.baseUrl}/active`);
    }

    deleteBudgetAccount(budgetAccount: IBudgetAccount): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${budgetAccount.id}`, { observe: 'response' });
    }

    createBudgetAccount(budgetAccount: IBudgetAccount): Observable<HttpResponse<IBudgetAccount>> {
        return this.http.post<IBudgetAccount>(this.baseUrl, budgetAccount, { observe: 'response' });
    }

    updateBudgetAccount(budgetAccount: IBudgetAccount): Observable<HttpResponse<IBudgetAccount>> {
        console.log(budgetAccount);
        return this.http.put<IBudgetAccount>(this.baseUrl, budgetAccount, { observe: 'response' });
    }

    searchBudgetAccounts(search: BudgetAccountSearch): Observable<HttpResponse<IBudgetAccount[]>> {
        return this.http.post<IBudgetAccount[]>(`${this.baseUrl}/search`, search, { observe: 'response' });
    }

    searchBudgetAccountsWithPagination(
        search: BudgetAccountSearch,
        params?: Pageable
    ): Observable<HttpResponse<IPage<IBudgetAccount>>> {
        return this.http.post<IPage<IBudgetAccount>>(`${this.baseUrl}/search/pageable`, search, {
            observe: 'response',
            params: httpParams(params),
        });
    }

    searchAutocomplete(autocomplete: IAccountAutocomplete): Observable<HttpResponse<IBudgetAccount[]>> {
        return this.http
            .post<IBudgetAccount[]>(`${this.baseUrl}/autocomplete`, autocomplete, {
                observe: 'response',
            })
            .pipe(
                map(results => results),
                catchError(() => [])
            );
    }

    searchAutocompleteAsync(autocomplete: IAccountAutocomplete): Observable<IBudgetAccount[]> {
        return this.http.post<IBudgetAccount[]>(`${this.baseUrl}/autocomplete`, autocomplete);
    }

    checkForContraAccountExistance(category: string, code: string) {
        return this.http.get<any>(`${this.baseUrl}/contra-account-exist/${category}/${code}`, { observe: 'response' });
    }

    importBudgetAccounts(): Observable<HttpResponse<KeyValueDTO>> {
        return this.http.get<KeyValueDTO>(`${this.baseUrl}/import`, { observe: 'response' });
    }

    checkAccounts(tenantId: string): Observable<HttpResponse<any>> {
        return this.http.get<any>(`${this.baseUrl}/check-accounts/${tenantId}`, { observe: 'response' });
    }

    downloadTemplate(): Observable<HttpResponse<any>> {
        return this.http.get(`${this.baseUrl}/download-template`, {
            observe: 'response',
            responseType: 'blob',
        });
    }

    uploadExcelFile(formData: FormData) {
        return this.http.post(`${this.baseUrl}/upload-excel`, formData, {
            observe: 'events',
            reportProgress: true,
        });
    }
    uploadExcelFileAndGetAccounts(formData: FormData) {
        return this.http.post<any>(`${this.baseUrl}/upload-excel`, formData, {
            observe: 'events',
            reportProgress: true,
        });
    }
    import(list: IBudgetAccount[]): Observable<HttpResponse<any>> {
        return this.http.post<any>(`${this.baseUrl}/import`, list, { observe: 'response' });
    }
}
